var _polygon, _polygon2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "googleplay",
    "data-name": "googleplay",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 224.99 224.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "StoreIcons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "131.47 84.41 83.91 57.23 117.45 103.94 131.47 84.41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "83.91 167.76 131.47 140.58 117.45 121.05 83.91 167.76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.79,47.7A6.44,6.44,0,0,0,59,54.13V170.87a6.49,6.49,0,0,0,3.22,5.6,6.42,6.42,0,0,0,2.61.82l46.51-64.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.85,0H46.14A46.19,46.19,0,0,0,0,46.14V178.85A46.19,46.19,0,0,0,46.14,225H178.85A46.19,46.19,0,0,0,225,178.85V46.14A46.19,46.19,0,0,0,178.85,0Zm-3.14,126.78L73.6,185.15A16.45,16.45,0,0,1,49,170.87V54.13A16.45,16.45,0,0,1,73.6,39.85L175.72,98.22a16.45,16.45,0,0,1,0,28.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.76,106.88,140.17,89.39,123.59,112.5l16.59,23.11,30.59-17.49a6.47,6.47,0,0,0,0-11.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.de6de4d3d19bdfa4bf3bdc2134645db1.svg";
export { ForwardRef as ReactComponent };